






















import { Component, Prop, Vue } from 'vue-property-decorator'
import { IVendor, IVendorLicense } from '@/api/types-vendor'
import { getVendorLicenses, deleteVendorLicenseList } from '@/api/vendors'

import VendorLicensesTable from './VendorLicensesTable.vue'
import EditLicenseDialog from './EditLicenseDialog.vue'

@Component({
  name: 'VendorLicenses',
  components: {
    VendorLicensesTable,
    EditLicenseDialog
  }
})
export default class extends Vue {
  @Prop({ default: false }) isEdit!: boolean;
  @Prop({ type: Object }) value!: IVendor;
  // License LIST
  selectedId = 0
  licenseTotal = 0
  licenseList: IVendorLicense[] = []
  licenseListLoading = true
  licenseListTitle = 'Loading...'
  editLicenseDialogVisible = false
  componentKey = 0

  async mounted() {
    this.$nextTick(() => {
      this.getList()
    })
  }

  async getList() {
    this.selectedId = 0
    this.licenseListTitle = 'Loading...'
    const vendorId = this.value.vendorId
    let list = this.licenseList
    console.log(`VendorLicenses.vue getList(${vendorId}) isEdit=${this.isEdit}`)
    if (this.selectedId !== vendorId) {
      list = []
    }
    if (list.length === 0) {
      const response = await getVendorLicenses(vendorId)
      list = response.data
    }
    this.licenseList = list
    this.selectedId = vendorId
    console.log(`VendorLicenses.vue got List (${list.length} Licenses found) `)
    this.licenseListLoading = false
    this.licenseListTitle = ''
    this.licenseTotal = list.length
    this.componentKey += 1
  }

  editLicense: IVendorLicense = {
    vendorLicenseId: 0,
    vendorId: 0,
    licenseTypeId: 0,
    state: '',
    licenseNumber: '',
    expirationDate: null,
    expirationDateString: null,
    licenseDocument: '',
    deleted: false
  }

  addNewLicense(): IVendorLicense {
    return {
      vendorLicenseId: 0,
      vendorId: this.value.vendorId,
      licenseTypeId: 0,
      state: this.value.state,
      licenseNumber: '',
      expirationDate: null,
      expirationDateString: null,
      licenseDocument: '',
      deleted: false
    }
  }

  handleAddLicense() {
    this.editLicense = this.addNewLicense()
    this.editLicenseDialogVisible = true
  }

  async handleLicenseDialogClose() {
    await this.getList()
    this.editLicenseDialogVisible = false
  }

  async handleLicenseDeleteMultiple(ids: number[]) {
    this.licenseListTitle = 'Deactivating License(s), please wait...'
    console.log(`VendorLicenses.vue before handleLicenseDeleteMultiple(${this.value.vendorId}, ${ids.length})`)
    const response = await deleteVendorLicenseList(this.value.vendorId, ids)
    console.log(`VendorLicenses.vue after handleLicenseDeleteMultiple(${response.data})`)
    await this.getList()
  }
}
